import AccountPayableReducer from "./account-payable";
import AccountReceiveableReducer from "./account-receiveable";
import AnalysisSalesScheduleReducer from "./analysis/sales-schedule";
import AssetReportReducer from "./asset-report";
import BalanceSheetReducer from "./balance-sheet";
import CashBankBookReducer from "./cash-bank";
import CashFlowReducer from "./cash-flow";
import CashReportReducer from "./cash-report";
import CustomerReportReducer from "./customer-report";
import GeneralLedgerReducer from "./general-ledger";
import IncomeStatementReducer from "./income-statement";
import PriceComparisonReportReducer from "./price-comparison";
import PurchasingReportReducer from "./purchasing-report";
import RankingSalesReportReducer from "./ranking-sales";
import SalesInvoiceReportReducer from "./sales-report";
import SalesTargetReportReducer from "./sales-target-report";
import TrackingPurchasingReducer from "./tracking-purchasing";
import TrackingSalesReducer from "./tracking-sales";
import UncollectedDebtReducer from "./uncollected-debt";
import WorkSheetReducer from "./work-sheet";

export default {
  accountPayable: AccountPayableReducer,
  accountReceiveable: AccountReceiveableReducer,
  analysisSalesSchedule: AnalysisSalesScheduleReducer,
  assetReport: AssetReportReducer,
  balanceSheet: BalanceSheetReducer,
  cashbankBook: CashBankBookReducer,
  workSheet: WorkSheetReducer,
  cashFlow: CashFlowReducer,
  customerReport: CustomerReportReducer,
  generalLedger: GeneralLedgerReducer,
  incomeStatement: IncomeStatementReducer,
  priceComparisonReport: PriceComparisonReportReducer,
  purchasingReport: PurchasingReportReducer,
  rankingSalesReport: RankingSalesReportReducer,
  salesInvoiceReport: SalesInvoiceReportReducer,
  salesTargetReport: SalesTargetReportReducer,
  trackingPurchasing: TrackingPurchasingReducer,
  trackingSales: TrackingSalesReducer,
  uncollectedDebt: UncollectedDebtReducer,
  cashReport: CashReportReducer,
};
